<template>
  <div id="referrals">  
    <div class="recorrido">
      <div class="step">
        <link-icon size="1.5x" class="custom-class"></link-icon>
        <div class="texto">
          <h3>{{ $t('dealers.copy') }}</h3>
          <p>{{ $t('dealers.copyYourLink') }}</p>
        </div>
      </div>
      <div class="step">
        <send-icon size="1.5x" class="custom-class"></send-icon>
        <div class="texto">
          <h3>{{ $t('dealers.share') }}</h3>
          <p>{{ $t('dealers.itIsSimple') }}</p>
        </div>
      </div>
      <div class="step">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="90" height="90"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1.95-9H15v2h-4.95a2.5 2.5 0 0 0 4.064 1.41l1.7 1.133A4.5 4.5 0 0 1 8.028 13H7v-2h1.027a4.5 4.5 0 0 1 7.788-2.543L14.114 9.59A2.5 2.5 0 0 0 10.05 11z" fill="rgba(0,64,255,1)"/></svg>
        <div class="texto">
          <h3>{{ $t('dealers.win') }}</h3>
          <p>{{ $t('dealers.20%') }}</p>
        </div>
      </div>
    </div>
    <div class="card-content">
      <p class="enlace">{{ $t('permanent') }}</p>
      <div class="contenedor-enlaces">
        <div class="link-container">
          <p class="link">{{ link }}</p>
          <button class="button button-copy"
          :data-clipboard-text="link"
          :aria-label="$t('buttons.copyToClipboard')"
          :title="$t('buttons.copy')">
            <link-icon size="1x" class="custom-class"></link-icon>
            <p>{{ $t('buttons.copy') }}</p>
          </button>
        </div>
        <div class="icono-enlace">
          <a :href="urlWhatsapp" target="_blank" @mouseenter="mouseEnterWhatsapp" @mouseleave="mouseLeaveWhatsapp">
            <svg v-if="!isWhatsapp" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M7.253 18.494l.724.423A7.953 7.953 0 0 0 12 20a8 8 0 1 0-8-8c0 1.436.377 2.813 1.084 4.024l.422.724-.653 2.401 2.4-.655zM2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308c.134-.01.269-.01.403-.004.054.004.108.01.162.016.159.018.334.115.393.249.298.676.588 1.357.868 2.04.062.152.025.347-.093.537a4.38 4.38 0 0 1-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268.12.116.237.235.363.346.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11.062.026.126.049.191.066a.35.35 0 0 0 .367-.13c.724-.877.79-.934.796-.934v.002a.482.482 0 0 1 .378-.127c.06.004.121.015.177.04.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265.004.067.01.175-.013.373-.032.259-.11.57-.188.733a1.155 1.155 0 0 1-.21.302 2.378 2.378 0 0 1-.33.288 3.71 3.71 0 0 1-.125.09 5.024 5.024 0 0 1-.383.22 1.99 1.99 0 0 1-.833.23c-.185.01-.37.024-.556.014-.008 0-.568-.087-.568-.087a9.448 9.448 0 0 1-3.84-2.046c-.226-.199-.435-.413-.649-.626-.89-.885-1.562-1.84-1.97-2.742A3.47 3.47 0 0 1 6.9 9.62a2.729 2.729 0 0 1 .564-1.68c.073-.094.142-.192.261-.305.127-.12.207-.184.294-.228a.961.961 0 0 1 .371-.1z"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M7.253 18.494l.724.423A7.953 7.953 0 0 0 12 20a8 8 0 1 0-8-8c0 1.436.377 2.813 1.084 4.024l.422.724-.653 2.401 2.4-.655zM2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308c.134-.01.269-.01.403-.004.054.004.108.01.162.016.159.018.334.115.393.249.298.676.588 1.357.868 2.04.062.152.025.347-.093.537a4.38 4.38 0 0 1-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268.12.116.237.235.363.346.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11.062.026.126.049.191.066a.35.35 0 0 0 .367-.13c.724-.877.79-.934.796-.934v.002a.482.482 0 0 1 .378-.127c.06.004.121.015.177.04.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265.004.067.01.175-.013.373-.032.259-.11.57-.188.733a1.155 1.155 0 0 1-.21.302 2.378 2.378 0 0 1-.33.288 3.71 3.71 0 0 1-.125.09 5.024 5.024 0 0 1-.383.22 1.99 1.99 0 0 1-.833.23c-.185.01-.37.024-.556.014-.008 0-.568-.087-.568-.087a9.448 9.448 0 0 1-3.84-2.046c-.226-.199-.435-.413-.649-.626-.89-.885-1.562-1.84-1.97-2.742A3.47 3.47 0 0 1 6.9 9.62a2.729 2.729 0 0 1 .564-1.68c.073-.094.142-.192.261-.305.127-.12.207-.184.294-.228a.961.961 0 0 1 .371-.1z" fill="rgba(0,64,255,1)"/></svg>
          </a>
          <a :href="urlMail" target="_blank" @mouseenter="mouseEnterMail" @mouseleave="mouseLeaveMail">
            <svg v-if="!isMail" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z" fill="rgba(0,64,255,1)"/></svg>
          </a>
          <a :href="urlLinkedin" target="_blank" @mouseenter="mouseEnterLinkedin" @mouseleave="mouseLeaveLinkedin">
            <svg v-if="!isLinkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h14V5H5zm2.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-1 1h2v7.5h-2V10zm5.5.43c.584-.565 1.266-.93 2-.93 2.071 0 3.5 1.679 3.5 3.75v4.25h-2v-4.25a1.75 1.75 0 0 0-3.5 0v4.25h-2V10h2v.43z"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h14V5H5zm2.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-1 1h2v7.5h-2V10zm5.5.43c.584-.565 1.266-.93 2-.93 2.071 0 3.5 1.679 3.5 3.75v4.25h-2v-4.25a1.75 1.75 0 0 0-3.5 0v4.25h-2V10h2v.43z" fill="rgba(0,64,255,1)"/></svg>
          </a>
          <a :href="urlTwitter" target="_blank" @mouseenter="mouseEnterTwitter" @mouseleave="mouseLeaveTwitter">
            <svg v-if="!isTwitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M15.3 5.55a2.9 2.9 0 0 0-2.9 2.847l-.028 1.575a.6.6 0 0 1-.68.583l-1.561-.212c-2.054-.28-4.022-1.226-5.91-2.799-.598 3.31.57 5.603 3.383 7.372l1.747 1.098a.6.6 0 0 1 .034.993L7.793 18.17c.947.059 1.846.017 2.592-.131 4.718-.942 7.855-4.492 7.855-10.348 0-.478-1.012-2.141-2.94-2.141zm-4.9 2.81a4.9 4.9 0 0 1 8.385-3.355c.711-.005 1.316.175 2.669-.645-.335 1.64-.5 2.352-1.214 3.331 0 7.642-4.697 11.358-9.463 12.309-3.268.652-8.02-.419-9.382-1.841.694-.054 3.514-.357 5.144-1.55C5.16 15.7-.329 12.47 3.278 3.786c1.693 1.977 3.41 3.323 5.15 4.037 1.158.475 1.442.465 1.973.538z"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M15.3 5.55a2.9 2.9 0 0 0-2.9 2.847l-.028 1.575a.6.6 0 0 1-.68.583l-1.561-.212c-2.054-.28-4.022-1.226-5.91-2.799-.598 3.31.57 5.603 3.383 7.372l1.747 1.098a.6.6 0 0 1 .034.993L7.793 18.17c.947.059 1.846.017 2.592-.131 4.718-.942 7.855-4.492 7.855-10.348 0-.478-1.012-2.141-2.94-2.141zm-4.9 2.81a4.9 4.9 0 0 1 8.385-3.355c.711-.005 1.316.175 2.669-.645-.335 1.64-.5 2.352-1.214 3.331 0 7.642-4.697 11.358-9.463 12.309-3.268.652-8.02-.419-9.382-1.841.694-.054 3.514-.357 5.144-1.55C5.16 15.7-.329 12.47 3.278 3.786c1.693 1.977 3.41 3.323 5.15 4.037 1.158.475 1.442.465 1.973.538z" fill="rgba(0,64,255,1)"/></svg>
          </a>
        </div>
      </div>
    </div>
    <div class="referred-users">
      <div class="information">
        <p class="referrals">{{ $t('dealers.referredUsers') }}</p>
        <p class="price">{{ this.earnedMoney }}€</p>
      </div>
      <div class="card" v-if="referred.length > 0">
        <div class="card-title">
          <p class="email">{{ $t('dealers.email') }}</p>
          <p class="bonus">{{ $t('dealers.bonus') }}</p>
          <p class="creacion">{{ $t('dealers.creationDate') }}</p>
        </div>
        <div class="card-content">
          <div id="listing">
            <div class="invoicelist">
              <referred-users v-for="(item) in referred" :key="item.id"
                v-bind:bonus="item.bonus"
                v-bind:email="item.email"
                v-bind:ctime="item.ctime"> 
              </referred-users>
            </div>
          </div>
        </div>
      </div>  
      <div class="card" v-else>
        <div class="card-content">
          <div class="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M1 22a8 8 0 1 1 16 0H1zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm9.246-9.816A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22zm3.302-2.4A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.216l-1.645-1.196A11.955 11.955 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784z" fill="rgba(0,64,255,1)"/></svg>
            <h2 class="message">
              <span>{{ $t('dealers.noUser') }}</span>
            </h2>
          </div>
        </div>
      </div>          
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Clipboard from 'clipboard';
import { files as ibbapi } from '@/api';
import { SendIcon, LinkIcon } from 'vue-feather-icons';
import ReferredUsers from '../../components/dealers/ReferredUsers.vue';
import { Base64 } from 'js-base64';

export default {
  name: 'dealers',
  components: {
    SendIcon,
    LinkIcon,
    ReferredUsers
  },
  data: function () {
    return {
      link: '',
      clip: null,
      urlTwitter: '',
      urlWhatsapp: '',
      urlMail: '',
      urlLinkedin: '',
      isTwitter: '',
      isWhatsapp: '',
      isMail: '',
      isLinkedin: '',
      referralsNumber: '',
      earnedMoney: '',
      referred: '',
    };
  },
  computed: {
    ...mapState([ 'referrerCode' ]),
  },
  async mounted () {
    try {
      let action = await ibbapi.getAccountInfo();
      this.setReferrerCode(action.accountInfo.referrercode);
      this.earnedMoney = (action.accountInfo.balance / 100).toFixed(2);
    } catch (e) {
      this.$showError(e);
    }

    this.clip = new Clipboard('.button-copy');
    this.clip.on('success', () => {
      this.$showSuccess(this.$t('success.linkCopied'));
    });

    this.link = 'https://' +window.location.host +'/register?' +'coupon=' +Base64.encodeURI(this.referrerCode);

    this.urlTwitter = 'http://twitter.com/intent/tweet?text=' +encodeURIComponent('Regístrate en Iberbox usando mi código promocional: ') +'&url=https://' +window.location.host +'/register?coupon=' + Base64.encodeURI(this.referrerCode);
    this.urlWhatsapp = 'https://api.whatsapp.com/send?text=' +encodeURIComponent('Regístrate en Iberbox usando mi código promocional: ') +'https://' +window.location.host +'/register?coupon=' + Base64.encodeURI(this.referrerCode);
    this.urlMail = 'mailto:?subject=' +encodeURIComponent('Código Promocional de Iberbox') +'&body=' +encodeURIComponent('Regístrate en Iberbox usando mi código promocional: ') +'https://' +window.location.host +'/register?coupon=' + Base64.encodeURI(this.referrerCode);
    this.urlLinkedin= 'https://www.linkedin.com/shareArticle?url=' +'https://iberbox.com/register?coupon%3D' + Base64.encodeURI(this.referrerCode);

    try {
      let action = await ibbapi.getBalancesInfo();
      let balancesReferrals = action.balancesInfo.balances.filter(b => b.type == Module.BalanceType.REFERRAL.value);
      action = await ibbapi.getReferralsInfo();
      this.referralsNumber = action.stringList.length;
      this.referred = action.stringList.map((v, i) => {
        let balance = balancesReferrals.find(b => b.subject == v);
        return {email: v, ctime: action.numberList[i], bonus: balance ? balance.amount : 0};
      });
    } catch (e) {
      this.$showError(e);
    }
  },
  beforeDestroy () {
    this.clip.destroy();
  },
  methods: {
    ...mapMutations([ 'setReferrerCode' ]),
    mouseEnterWhatsapp() {
      this.isWhatsapp = true;
    },
    mouseLeaveWhatsapp() {
      this.isWhatsapp = false;
    },
    mouseEnterMail() {
      this.isMail = true;
    },
    mouseLeaveMail() {
      this.isMail = false;
    },
    mouseEnterTwitter() {
      this.isTwitter = true;
    },
    mouseLeaveTwitter() {
      this.isTwitter = false;
    },
    mouseEnterLinkedin() {
      this.isLinkedin = true;
    },
    mouseLeaveLinkedin() {
      this.isLinkedin = false;
    },
  }
};
</script>